import { Circle, Group } from 'fabric';
import { mmToPixels } from './DecalEditorCanvasSizing';
const HOLE_RADIUS_MM = 2;
const HOLE_CORNER_OFFSET_MM = 5;
export const updateHolePlacement = (canvas, placement) => {
    removeHoles(canvas);
    if (placement === 'none') {
        canvas.renderAll();
        return;
    }
    const zoom = canvas.getZoom();
    const width = canvas.width / zoom;
    const height = canvas.height / zoom;
    const holeRadius = mmToPixels(HOLE_RADIUS_MM);
    const cornerOffset = mmToPixels(HOLE_CORNER_OFFSET_MM);
    const holes = [];
    if (placement === 'left-right') {
        const leftHole = new Circle({
            left: 0 + mmToPixels(HOLE_CORNER_OFFSET_MM),
            top: height / 2,
            radius: holeRadius,
            fill: 'white',
            stroke: '#999999',
            strokeWidth: 1,
            originX: 'center',
            originY: 'center',
            selectable: false,
            evented: false,
            id: 'hole-left',
            zIndex: 1000,
        });
        const rightHole = new Circle({
            left: width - mmToPixels(HOLE_CORNER_OFFSET_MM),
            top: height / 2,
            radius: holeRadius,
            fill: 'white',
            stroke: '#999999',
            strokeWidth: 1,
            originX: 'center',
            originY: 'center',
            selectable: false,
            evented: false,
            id: 'hole-right',
            zIndex: 1000,
        });
        holes.push(leftHole, rightHole);
    }
    else if (placement === 'corners') {
        const topLeftHole = new Circle({
            left: cornerOffset,
            top: cornerOffset,
            radius: holeRadius,
            fill: 'white',
            stroke: '#999999',
            strokeWidth: 1,
            originX: 'center',
            originY: 'center',
            selectable: false,
            evented: false,
            id: 'hole-topleft',
            zIndex: 1000,
        });
        const topRightHole = new Circle({
            left: width - cornerOffset,
            top: cornerOffset,
            radius: holeRadius,
            fill: 'white',
            stroke: '#999999',
            strokeWidth: 1,
            originX: 'center',
            originY: 'center',
            selectable: false,
            evented: false,
            id: 'hole-topright',
            zIndex: 1000,
        });
        const bottomLeftHole = new Circle({
            left: cornerOffset,
            top: height - cornerOffset,
            radius: holeRadius,
            fill: 'white',
            stroke: '#999999',
            strokeWidth: 1,
            originX: 'center',
            originY: 'center',
            selectable: false,
            evented: false,
            id: 'hole-bottomleft',
            zIndex: 1000,
        });
        const bottomRightHole = new Circle({
            left: width - cornerOffset,
            top: height - cornerOffset,
            radius: holeRadius,
            fill: 'white',
            stroke: '#999999',
            strokeWidth: 1,
            originX: 'center',
            originY: 'center',
            selectable: false,
            evented: false,
            id: 'hole-bottomright',
            zIndex: 1000,
        });
        holes.push(topLeftHole, topRightHole, bottomLeftHole, bottomRightHole);
    }
    if (holes.length > 0) {
        const holesGroup = new Group(holes, {
            id: 'hole-group',
            selectable: false,
            evented: false,
            hoverCursor: 'default',
        });
        canvas.add(holesGroup);
    }
    canvas.set({
        'hole-placement': placement,
    });
    canvas.renderAll();
};
export const removeHoles = (canvas) => {
    const objects = canvas.getObjects();
    objects.forEach((obj) => {
        var _a;
        if (obj.id === 'hole-group' || ((_a = obj.id) === null || _a === void 0 ? void 0 : _a.toString().startsWith('hole-'))) {
            canvas.remove(obj);
        }
    });
};
